import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import type { ProductCatalogCollection } from './ProductCatalogCollection';

const newProductsCollection: ProductCatalogCollection = {
  description: t => t('Browse the latest additions to the Art of Where product catalog.'),
  matchesProduct: product => product.get('is_new'),
  navIcon: CampaignRoundedIcon,
  navTone: 'new',
  slug: 'new-products',
  title: t => t('New Products'),
};

export default newProductsCollection;
